'use client';
import React from 'react';
import {
  RadarChart,
  Radar,
  PolarGrid,
  PolarAngleAxis,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from 'recharts';

const DATA = [
  { type: 'MCQ', current: 72, target: 85 },
  { type: 'TF/NG', current: 61, target: 85 },
  { type: 'YN/NG', current: 58, target: 85 },
  { type: 'Match Info', current: 68, target: 85 },
  { type: 'Match Head', current: 54, target: 85 },
  { type: 'Match Feat', current: 63, target: 85 },
  { type: 'Match End', current: 70, target: 85 },
  { type: 'Completion', current: 66, target: 85 },
  { type: 'Short Ans', current: 74, target: 85 },
];

const CustomTooltip = ({ active, payload, label }: { active?: boolean; payload?: Array<{ name: string; value: number; color: string }>; label?: string }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-card border border-border rounded-lg shadow-elevated p-3 text-xs">
      <p className="font-semibold text-foreground mb-1.5">{label}</p>
      {payload.map((entry, i) => (
        <div key={`tooltip-${i}`} className="flex items-center gap-2">
          <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: entry.color }} />
          <span className="text-muted-foreground">{entry.name}:</span>
          <span className="font-semibold text-foreground tabular-nums">{entry.value}%</span>
        </div>
      ))}
    </div>
  );
};

export default function AccuracyRadarChart() {
  return (
    <div className="card-base p-5">
      <div className="flex items-start justify-between mb-4">
        <div>
          <h2 className="section-header">Accuracy by Question Type</h2>
          <p className="text-xs text-muted-foreground mt-0.5">All 9 IELTS Reading question types · Last 7 sessions</p>
        </div>
        <span className="text-xs font-medium text-muted-foreground bg-muted px-2 py-1 rounded-md">Band 8+ threshold: 85%</span>
      </div>
      <ResponsiveContainer width="100%" height={280}>
        <RadarChart data={DATA} cx="50%" cy="50%" outerRadius="75%">
          <PolarGrid stroke="var(--border)" />
          <PolarAngleAxis
            dataKey="type"
            tick={{ fontSize: 11, fill: 'var(--muted-foreground)', fontFamily: 'var(--font-plus-jakarta-sans)' }}
          />
          <Radar
            name="Your accuracy"
            dataKey="current"
            stroke="var(--primary)"
            fill="var(--primary)"
            fillOpacity={0.15}
            strokeWidth={2}
          />
          <Radar
            name="Band 8+ target"
            dataKey="target"
            stroke="var(--accent)"
            fill="var(--accent)"
            fillOpacity={0.05}
            strokeWidth={1.5}
            strokeDasharray="4 3"
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend
            iconType="circle"
            iconSize={8}
            formatter={(value) => (
              <span style={{ fontSize: '12px', color: 'var(--muted-foreground)' }}>{value}</span>
            )}
          />
        </RadarChart>
      </ResponsiveContainer>
      {/* Weakest type callout */}
      <div className="mt-3 flex items-center gap-2 p-2.5 rounded-lg bg-danger-bg border border-danger/20">
        <span className="w-2 h-2 rounded-full bg-danger flex-shrink-0" />
        <p className="text-xs text-danger font-medium">
          Matching Headings (54%) is your biggest band-loss risk — 9 questions per test
        </p>
      </div>
    </div>
  );
}